export async function fecharModalComRecarregamentoGrid({ fecharModal, recarregarGrid } = {}) {
  if (typeof fecharModal === "function") {
    fecharModal();
  }

  if (typeof recarregarGrid === "function") {
    await recarregarGrid();

    await new Promise((resolve) => setTimeout(resolve, 450));
    await recarregarGrid();
  }
}
